import React, { useEffect, useState } from "react";
import "./style.css";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import Ucarlist from "../../components/Ucarlist";
import { getUcar } from "../../fnc/getUcar";

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [ucarData, setUcarData] = useState([]);
  const [ucarSerchData, setUcarSerchData] = useState([]);
  const [serchInput, setSerchInput] = useState("");
  const [sliderValue, setSliderValue] = React.useState([]);
  const [iniSliderValue, setIniSliderValue] = React.useState([]);
  const [kyoriSliderValue, setKyoriSliderValue] = React.useState([]);
  const [iniKyoriSliderValue, setIniKyoriSliderValue] = React.useState([]);
  // const [haikiryoSliderValue, setHaikiryoSliderValue] = React.useState([]);
  // const [iniHaikiryoSliderValue, setIniHaikiryoSliderValue] = React.useState(
  //   []
  // );
  const [nensikiSliderValue, setNensikiSliderValue] = React.useState([]);
  const [iniNensikiSliderValue, setIniNensikiSliderValue] = React.useState([]);
  const [makerChecked, setMakerChecked] = React.useState({
    toyota: false,
    nonToyota: false,
    imported: false,
  });
  const [keiChecked, setKeiChecked] = React.useState({
    futusya: false,
    kei: false,
  });
  const [powerChecked, setPowerChecked] = React.useState({
    hev: false,
  });
  const [kudoChecked, setKudoChecked] = React.useState({
    awd: false,
  });
  const [isOpen, setIsOpen] = useState(false);

  // 年式を年と月に分解する関数
  const splitNensiki = (nensiki) => {
    if (nensiki && nensiki.length === 6) {
      const year = parseInt(nensiki.substring(0, 4), 10);
      const month = parseInt(nensiki.substring(4, 6), 10);
      return { year, month };
    }
    return null;
  };

  useEffect(() => {
    const fetchUcarData = async () => {
      let _ucarData = await getUcar(`${process.env.REACT_APP_API_URL}`);
      let _ucarDataSort = [..._ucarData].sort((a, b) => {
        // 最新（newFlag）を最優先にソート
        if (b.newFlag && !a.newFlag) return 1;
        if (a.newFlag && !b.newFlag) return -1;

        // カミングF（数字のテキストとして）を次にソート
        let comingA = parseInt(a.comingF, 10);
        let comingB = parseInt(b.comingF, 10);
        if (comingA < comingB) return -1;
        if (comingA > comingB) return 1;

        // 価格（hanbaiprice）を最後にソート
        return a.hanbaiprice - b.hanbaiprice;
      });
      const maxPrice =
        Math.ceil(
          Math.max(..._ucarData.map((ucar) => ucar.hanbaipriceH)) / 10
        ) * 10;
      const minPrice =
        Math.floor(
          Math.min(..._ucarData.map((ucar) => ucar.hanbaipriceH)) / 10
        ) * 10;

      setSliderValue([minPrice, maxPrice]);
      setIniSliderValue([minPrice, maxPrice]);

      // 走行距離（haikiryo）を最後にソート
      const maxKyori =
        Math.ceil(Math.max(..._ucarData.map((ucar) => ucar.kyori)) / 10) * 10;
      const minKyori =
        Math.floor(Math.min(..._ucarData.map((ucar) => ucar.kyori)) / 10) * 10;

      setKyoriSliderValue([minKyori, maxKyori]);
      setIniKyoriSliderValue([minKyori, maxKyori]);

      // 排気量（haikiryo）を最後にソート
      // const maxHaikiryo =
      //   Math.ceil(Math.max(..._ucarData.map((ucar) => ucar.haikiryo)) / 10) *
      //   10;
      // const minHaikiryo =
      //   Math.floor(Math.min(..._ucarData.map((ucar) => ucar.haikiryo)) / 10) *
      //   10;

      // setHaikiryoSliderValue([minHaikiryo, maxHaikiryo]);
      // setIniHaikiryoSliderValue([minHaikiryo, maxHaikiryo]);

      let maxNensikiYear = -Infinity;
      let minNensikiYear = Infinity;
      let maxNensikiMonth = -Infinity;
      let minNensikiMonth = Infinity;
      _ucarData.forEach((ucar) => {
        const nensikiData = splitNensiki(ucar.nensiki);
        if (nensikiData) {
          const { year, month } = nensikiData;
          if (
            year > maxNensikiYear ||
            (year === maxNensikiYear && month > maxNensikiMonth)
          ) {
            maxNensikiYear = year;
            maxNensikiMonth = month;
          }
          if (
            year < minNensikiYear ||
            (year === minNensikiYear && month < minNensikiMonth)
          ) {
            minNensikiYear = year;
            minNensikiMonth = month;
          }
        }
      });

      const maxNensiki = maxNensikiYear !== -Infinity ? maxNensikiYear : null;
      const minNensiki = minNensikiYear !== Infinity ? minNensikiYear : null;

      if (maxNensiki && minNensiki) {
        setNensikiSliderValue([minNensiki, maxNensiki]);
        setIniNensikiSliderValue([minNensiki, maxNensiki]);
      }
      setLoading(false);
      setUcarData(_ucarDataSort);
      setUcarSerchData(_ucarDataSort);
    };

    fetchUcarData();
  }, []);

  useEffect(() => {
    const filteredData = ucarData.filter((data) => {
      const isToyota =
        makerChecked.toyota &&
        (data.makerkubun === "A" || data.makerkubun === "L");
      const isNonToyota =
        makerChecked.nonToyota &&
        !["L", "S", "V", "A"].includes(data.makerkubun);
      const isImported = makerChecked.imported && data.makerkubun === "S";
      const isKeiFutusya = keiChecked.futusya && !data.keikubun;
      const isKei = keiChecked.kei && data.keikubun === "1";
      const isHev =
        powerChecked.hev && ["HEV", "PHEV"].includes(data.powertrain);
      const isAwd = kudoChecked.awd && data.kudo === "4WD";

      const isKyoriInRange =
        parseInt(data.kyori, 10) >= kyoriSliderValue[0] &&
        parseInt(data.kyori, 10) <= kyoriSliderValue[1];

      // const isHaikiryoInRange =
      //   parseInt(data.haikiryo, 10) >= haikiryoSliderValue[0] &&
      //   parseInt(data.haikiryo, 10) <= haikiryoSliderValue[1];

      // 年式でフィルタリング
      const nensikiData = splitNensiki(data.nensiki);
      const isNensikiInRange = nensikiData
        ? nensikiData.year >= nensikiSliderValue[0] &&
          nensikiData.year <= nensikiSliderValue[1]
        : true;

      // 在庫IDまたは車名に検索入力がマッチするかどうか
      const isSearchMatched =
        data.zaiko_id.includes(serchInput) || data.syamei.includes(serchInput);

      const isMakerMatched =
        (makerChecked.toyota ||
          makerChecked.nonToyota ||
          makerChecked.imported) &&
        (isToyota || isNonToyota || isImported);

      return (
        Number(data.hanbaipriceH) >= Number(sliderValue[0]) &&
        Number(data.hanbaipriceH) <= Number(sliderValue[1]) &&
        // isHaikiryoInRange &&
        isKyoriInRange &&
        isNensikiInRange &&
        (isMakerMatched ||
          (!makerChecked.toyota &&
            !makerChecked.nonToyota &&
            !makerChecked.imported)) &&
        (isKeiFutusya || isKei || (!keiChecked.futusya && !keiChecked.kei)) &&
        isSearchMatched &&
        (powerChecked.hev ? isHev : true) &&
        (kudoChecked.awd ? isAwd : true)
      );
    });

    setUcarSerchData(filteredData);
    // console.log(filteredData);
  }, [
    ucarData,
    makerChecked,
    keiChecked,
    serchInput,
    sliderValue,
    kyoriSliderValue,
    // haikiryoSliderValue,
    nensikiSliderValue,
    powerChecked,
    kudoChecked,
  ]);

  const menuClass = isOpen ? "sidebarMain active" : "sidebarMain";
  const listMaskClass = isOpen
    ? "sidebarList-wraper-mask active"
    : "sidebarList-wraper-mask";

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <div className='home'>
        <Header
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          ucarSerchData={ucarSerchData}
        />

        <div className='sidebarList-wraper'>
          <div className={listMaskClass} onClick={handleClick}></div>
          <div className={menuClass}>
            <Sidebar
              className='textSerch'
              ucarData={ucarData}
              setUcarData={setUcarData}
              ucarSerchData={ucarSerchData}
              setUcarSerchData={setUcarSerchData}
              sliderValue={sliderValue}
              setSliderValue={setSliderValue}
              iniSliderValue={iniSliderValue}
              kyoriSliderValue={kyoriSliderValue}
              setKyoriSliderValue={setKyoriSliderValue}
              iniKyoriSliderValue={iniKyoriSliderValue}
              // haikiryoSliderValue={haikiryoSliderValue}
              // setHaikiryoSliderValue={setHaikiryoSliderValue}
              // iniHaikiryoSliderValue={iniHaikiryoSliderValue}
              nensikiSliderValue={nensikiSliderValue}
              setNensikiSliderValue={setNensikiSliderValue}
              iniNensikiSliderValue={iniNensikiSliderValue}
              makerChecked={makerChecked}
              setMakerChecked={setMakerChecked}
              keiChecked={keiChecked}
              setKeiChecked={setKeiChecked}
              serchInput={serchInput}
              setSerchInput={setSerchInput}
              powerChecked={powerChecked}
              setPowerChecked={setPowerChecked}
              kudoChecked={kudoChecked}
              setKudoChecked={setKudoChecked}
              isOpen={isOpen}
            />
          </div>
          <div className='ucarListPrev'>
            <div>
              {loading ? (
                <h1>ロード中…</h1>
              ) : (
                <Ucarlist ucarSerchData={ucarSerchData} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
